import { ExtendedPriceTypeData } from './types';

export default class ZonePriceTypeMap {
  private map: Map<number, Map<number, ExtendedPriceTypeData>> = new Map();

  constructor(priceTypes: ExtendedPriceTypeData[]) {
    priceTypes.forEach((priceType) => {
      const priceTypeId = priceType.price_type;
      const zoneId = priceType.zone_no;

      let zonePriceTypes = this.map.get(zoneId);

      if (zonePriceTypes === undefined) {
        zonePriceTypes = new Map<number, ExtendedPriceTypeData>();

        this.map.set(zoneId, zonePriceTypes);
      }

      zonePriceTypes.set(priceTypeId, priceType);
    });
  }

  getPriceType(zoneId: number, priceTypeId: number) {
    const zonePriceTypes = this.map.get(zoneId);

    if (zonePriceTypes) {
      const priceType = zonePriceTypes.get(priceTypeId);

      if (priceType) {
        return priceType;
      }
    }

    return null;
  }

  getZonePriceTypes(zoneId: number) {
    const zonePriceTypes = this.map.get(zoneId);

    if (zonePriceTypes) {
      return Array.from(zonePriceTypes.values());
    }

    return [];
  }
}
